const lang = {
  intro: {
    title: "Explore The World of Dining",
    paragraph:
      "<p>As part of your American Express Global Dining Credit benefit, we’ve curated a selection of over 2000+ restaurants in %COUNT% countries for you to explore. So whether it’s a new restaurant locally or on the other side of the world, where will you dine next?</p>",
    tcLink: "View full dining benefit details and T&Cs",
    hotelRestaurant:
      "* Please note that if you’re staying in a hotel, this credit will be applied only when settling the restaurant bill directly with the restaurant, separate from the overall hotel payment.",
  },
  filters: {
    country: "Country:",
    state: "State:",
    stateDefault: "All states",
    city: "City:",
    cityDefault: "All cities",
    cuisine: "Cuisine:",
    cuisineDefault: "All cuisines",
  },
  results: {
    halal: "Halal",
    notAvailable: "Restaurants not available for this selection",
    viewmap: "View on map",
    makebooking: "Make a booking:",
    makebookingTel: "Phone to book:",
    orderOnline: "To order please visit:",
    deliveryTakeaway: "Delivery/Take-Away available",
    deliveryProvidoor: "Delivery available via Providoor",
    openingSoon: "Opening soon",
    onlineOnly: "Online Only",
    new: "NEW",
    locations: "locations",
    button: "View locations",
    groupCuisine: "Various cuisines",
    close: "Close",
    bookNow: "Book now",
  },
  pocket: {
    title: "Explore 800+ restaurants and book directly with Pocket Concierge",
    button: "Visit Pocket Concierge",
  },
  pocketCard: {
    title: "Pocket Concierge",
    description:
      "Discover and book the best restaurants in Japan (only restaurants accepted prepaid are eligible)",
    cuisines: "Various cuisines",
    instruction: "Make a booking:",
    button: "Visit Pocket Concierge",
  },
  footer: {
    disclaimer:
      "<p>This benefit requires enrolment and applicable only for Centurion and Platinum Cardmembers.</p><p>Further details to be found in the T&Cs when enrolling into the offer.</p><p>”Participating local restaurants” means participating restaurants located in Finland</p><p>”Participating abroad restaurants” are participating restaurants located outside of Finland</p><p>For full offer details, please refer to the marketing email communication you received.</p><ul><li><a href='https://www.americanexpress.com/fi/legal/yksityisyys/'>Privacy Center</a></li><li><a href='https://www.americanexpress.com/fi/legal/yksityisyys/cookies/'>Cookie Policy</a></li></ul><p>Copyright © 2023 American Express Company</p>",
  },
};

export default lang;
